import { FrontendEnvironmentSettings } from '@act/shared/environment';
import { useEffect, useState } from 'react';
import { apiDomain } from 'toolkit/environment/api-domain';
import { setEnvironment } from 'toolkit/environment/environment/environment';
import { initializeUserMonitoring } from 'toolkit/environment/environment/user-monitoring';

export function useGetAppConfig() {
  const [gotAppConfig, setGotAppConfig] = useState(false);

  useEffect(() => {
    const configUrl = `${apiDomain}/client-config`;
    fetch(configUrl, {
      method: 'get',
      headers: {
        'Content-Type': `application/json`,
      },
    }).then(response => {
      response.text().then((bodyString: string) => {
        const environmentSettings = JSON.parse(
          bodyString
        ) as FrontendEnvironmentSettings;

        setEnvironment(environmentSettings);
        initializeUserMonitoring(environmentSettings);
        setGotAppConfig(true);
      });
    });
  }, []);
  return gotAppConfig;
}
